const charset = "0123456789abcdef".split("");
const base16 = 16;

/**
 * Converts an an integer to HEX (base16)
 */
export const encode = (int: bigint) => {
  const zero = BigInt(0);
  if (int === zero) {
    return "0";
  }

  const str: string[] = [];
  const length = BigInt(charset.length);
  const base10 = 10;
  while (int > zero) {
    str.unshift(charset[parseInt((int % length).toString(base10), 10)]);
    // BigInt division is automatically rounded down
    int = BigInt(int / length);
  }

  return str.join("");
};

/**
 * Converts a base16 (hex) string to an integer
 */
export const decode = (str: string) =>
  str
    .split("")
    .reverse()
    .reduce((prev, char, i) => prev + BigInt(charset.length) ** BigInt(i) * BigInt(charset.indexOf(char)), BigInt(0));

/**
 * Converts a string into its hex representation
 */
export const encodeAscii = (str: string) =>
  str
    .split("")
    .map((char) => char.charCodeAt(0))
    .map((code) => code.toString(base16).padStart(2, "0"))
    .join("");

/**
 * Converts a string representing hex pairs into its ascii representation
 */
export const decodeAscii = (str: string) =>
  (str.replace(/[^a-f0-9].*/i, "").match(/.{2}/g) ?? [])
    .map((pair) => parseInt(pair, base16))
    .map((code) => String.fromCharCode(code))
    .join("");
